// src/components/StatUpgradeModal.js
import { useEffect, useState } from 'react';
import { saveSlot } from '../features/game/saveSlots';

export default function StatUpgradeModal({ open, points=5, hero, setHero, slotIndex, onClose }) {
  const [remain, setRemain] = useState(points);

  useEffect(()=>{ if(open) setRemain(points); }, [open, points]);

  if (!open) return null;

  const add = (k)=>{
    if (remain <= 0) return;
    setHero(h => ({...h, [k]: h[k]+1}));
    setRemain(r => r-1);
  };

  const finish = ()=>{
    if (remain > 0) return; // ❗ ต้องใช้แต้มให้หมด
    const progress = JSON.parse(localStorage.getItem('progress')||'{}');
    saveSlot(slotIndex ?? 0, hero, progress);
    onClose();
  };

  return (
    <div className="modal">
      <div className="modal-card">
        <h2>Distribute Points (+{points})</h2>
        <p style={{opacity:.85}}>แต้มคงเหลือ: <b>{remain}</b> · ใช้ให้หมดเพื่อไปต่อ</p>
        <div className="row" style={{gap:8}}>
          <button className="btn" disabled={remain<=0} onClick={()=>add('str')}>+ STR</button>
          <button className="btn" disabled={remain<=0} onClick={()=>add('agi')}>+ AGI</button>
          <button className="btn" disabled={remain<=0} onClick={()=>add('int')}>+ INT</button>
        </div>
        <div style={{marginTop:8,fontSize:13}}>Now → STR {hero.str} · AGI {hero.agi} · INT {hero.int}</div>
        <div className="row" style={{marginTop:10}}>
          <button className={`btn primary${remain>0?' disabled':''}`} disabled={remain>0} onClick={finish}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
